import React from 'react'
import { convertPathPoitToLatLng } from '../../utils/helperFunctions'
import { renderToStaticMarkup } from 'react-dom/server'
import { ReactComponent as PoiWrapper } from "../../assets/icons/general/poi_wrapper.svg";
import common_types from '../../common_files/common_types';
import { Marker,Popup } from 'react-leaflet';
import L from 'leaflet';
import { Button } from '@mui/material';

import { ReactComponent as DeleteIcon } from "../../assets/icons/toursManagement/delete.svg";
import { ReactComponent as UpdateIcon } from "../../assets/icons/toursManagement/update.svg";
import { ReactComponent as MoveIcon } from "../../assets/icons/toursManagement/move.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/toursManagement/info.svg";


const POI_red_wrapper_Icon= renderToStaticMarkup(<span style={{color:'#FF3239'}}><PoiWrapper /></span>)


function TaskIcon ({task,addAnotherTaskToExistTask=null}){
    const location = convertPathPoitToLatLng(task.task_point);
    const wrapper = POI_red_wrapper_Icon

    let  htmlContent =
        `<div style="display:flex;justify-content:center;align-items:center;position:relative;bottom:25px;">
            <div style="position:absolute;">${wrapper}</div>
                <div style="position:relative;bottom:6px;height:25px;width:35px;display:flex;justify-content:center;align-items:center;font-size:16px;color:white;">
                    <b>
                        ${
                                task.task_type === common_types.task_type.TRIGGERED_TASK_SMS ? 'S'
                            :
                                task.task_type === common_types.task_type.TRIGGERED_TASK_WAIT ? 'T' 
                            :
                                task.task_type === common_types.task_type.TRIGGERED_TASK_PLAY_SOUND ? 'P'    
                            :
                                ""
                        }
                    </b>
                </div>
        </div>`
    ;


    return ( 
        <>
        <Marker  
            eventHandlers={{
                click: (e) => {
                    !e.target.isPopupOpen() ? e.target.closePopup(): e.target.openPopup()},
              
            }}
            position={location}
            icon={
                L.divIcon({
                    className: "my-custom-pin",
                    html: htmlContent
                })
            }
            
        >
            <Popup position={"top-center"} offset={[0,-20]}>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                    {
                            task.task_type === common_types.task_type.TRIGGERED_TASK_WAIT
                        ? 
                            <>
                                <span style={{color:'black',fontSize:'1.2rem',fontWeight:'bold'}}>
                                Timeout
                            </span> 
                            <span style={{color:'black',fontSize:'1rem'}}>
                                {`seconds: ${task.data.wait_time_seconds}` }
                            </span>
                            </>
                        :
                            task.task_type === common_types.task_type.TRIGGERED_TASK_PLAY_SOUND
                        ?   
                            <>
                                <span style={{color:'black',fontSize:'1.2rem',fontWeight:'bold'}}>
                                    Play sound
                                </span> 
                                <span style={{color:'black',fontSize:'1rem'}}>
                                    {`File name: ${task.data.file_name}`}
                                </span>
                                <span style={{color:'black',fontSize:'1rem'}}>
                                    {`Wait until sound end: ${task.data.wait_until_sound_ended ?'Yes' : 'No'}`}
                                </span>
                            </>
                        :
                            task.task_type === common_types.task_type.TRIGGERED_TASK_SMS
                        ?   
                            <>
                                <span style={{color:'black',fontSize:'1.2rem',fontWeight:'bold'}}>
                                    SMS
                                </span> 
                                <span style={{color:'black',fontSize:'1rem'}}>
                                    {`Text: ${task.data.text}`}
                                </span>
                                <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'center'}}>
                                    {task.data.value.map((item,index)=>(
                                        <span key={index+""+item} style={{color:'black',fontSize:'0.8rem'}}>{item}</span>
                                    ))}
                                </div>
                            </>
                        :
                            ""
                    }
                   {    
                            addAnotherTaskToExistTask !== null 
                        && 
                            <Button 
                                onClick={()=>{
                                    addAnotherTaskToExistTask(task.task_point,task.pathIndex,task.pointIndex);
                                }}
                            >
                                Add another task
                            </Button>
                    }
                </div>
            </Popup>
        </Marker>
        </>)
}

const MemomizedTaskIcon = React.memo(TaskIcon); 

export default MemomizedTaskIcon;